var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRightWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 14,
    viewBox: "0 0 9 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.910826 0.577452C1.23626 0.252015 1.7639 0.252015 2.08934 0.577452L7.92267 6.41079C8.24811 6.73622 8.24811 7.26386 7.92267 7.5893L2.08934 13.4226C1.7639 13.7481 1.23626 13.7481 0.910826 13.4226C0.585389 13.0972 0.585389 12.5696 0.910826 12.2441L6.1549 7.00004L0.910826 1.75596C0.585389 1.43053 0.585389 0.902889 0.910826 0.577452Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightWhite);
export default __webpack_public_path__ + "static/media/arrow-right-white.7d657cea4a465af2a62b8d73786f4988.svg";
export { ForwardRef as ReactComponent };